import { Grid } from "@material-ui/core"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import {
  StyledDetailHeader,
  StyledDetailLocation,
  StyledDetailSubheader,
  StyledDetailSubheaderContent,
} from "./MapTypography"
import { Image } from "react-image-and-background-image-fade"
import cropin_logo from "../../images/cropin-logo.png"
import no_poverty from "../../images/no-poverty.png"
import zero_hunger from "../../images/zero-hunger.png"
import decent_work from "../../images/decent-work.png"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"

const StyledLogoWrapper = styled.div`
  width: 50%;
  margin-bottom: 5%;

  ${breakpoint.md} {
    width: 40%;
  }
`

const StyledInvestmentThemeWrapper = styled.div`
  width: 100%;
  border-bottom: 2px solid #0f6494;
  padding-top: 8px;
  padding-bottom: 8px;

  ${breakpoint.lg} {
    border-bottom: 3px solid #0f6494;
    padding-top: 12px;
    padding-bottom: 12px;
  }
`

const CropinMapDetailMobile = () => {
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <StyledLogoWrapper>
            <Image
              src={cropin_logo}
              width="628px"
              height="274px"
              isResponsive
              disableLoader
              alt="CropIn"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </StyledLogoWrapper>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <div style={{ marginBottom: "1%" }}>
          <StyledDetailHeader>Agri-tech</StyledDetailHeader>
        </div>
      </Grid>
      <Grid item xs={12}>
        <StyledDetailLocation>Based in India</StyledDetailLocation>
      </Grid>
      <Grid container>
        <Grid item xs={12} container alignItems="center">
          <StyledInvestmentThemeWrapper>
            <Grid item xs={12}>
              <div style={{ marginBottom: "1%" }}>
                <StyledDetailSubheader>Investment Theme</StyledDetailSubheader>
              </div>
            </Grid>
            <Grid item xs={12}>
              <StyledDetailSubheaderContent>
                Sustainable Food & Agricultures
              </StyledDetailSubheaderContent>
            </Grid>
          </StyledInvestmentThemeWrapper>
        </Grid>
        <Grid item xs={12}>
          <StyledDetailSubheader style={{ marginTop: "16px" }}>
            About the Company
          </StyledDetailSubheader>
          <StyledDetailSubheaderContent>
            Agri-tech platform enabling data-driven farming by connecting all
            stakeholders in the agri-ecosystem.
          </StyledDetailSubheaderContent>
          <StyledDetailSubheader style={{ marginTop: "16px" }}>
            Impact Thesis
          </StyledDetailSubheader>
          <StyledDetailSubheaderContent>
            Improving the productivity and livelihood of smallholder farmers and
            driving greater efficiency in agri supply-chains.
          </StyledDetailSubheaderContent>
        </Grid>
      </Grid>
      <div style={{ width: "100%", marginTop: "10%" }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Image
              src={no_poverty}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="no poverty"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
          <Grid item xs={3}>
            <Image
              src={zero_hunger}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="zero hunger"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
          <Grid item xs={3}>
            <Image
              src={decent_work}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="decent work and economic growth"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
        </Grid>
      </div>
    </>
  )
}

export default CropinMapDetailMobile
